import React from 'react'
import ZoneDepthText from './ZoneDepthText.tsx'
import {
    useChartOptions,
    useShouldShowNormalized,
    useStrikeZoneType,
} from '../../Context/ChartContext.tsx'
import { ChartOptions } from '../../schema/types.ts'
import ZoneScaleText from './ZoneScaleText.tsx'
import useFlag from '../../Context/useFlag.ts'

type HomePlateProps = {
    pitcherPerspective?: boolean
    showMidPlateShadow?: boolean
    showFrontPlateShadow?: boolean
}

function shouldShowPlateDepthLegend({ chartType, overlayType }: ChartOptions) {
    const overlayTypes = ['pitch', 'hexbin', 'contour', 'pie']
    return chartType === 'pitch' && overlayTypes.includes(overlayType)
}

export default function HomePlate({
    pitcherPerspective = false,
    showMidPlateShadow = false,
    showFrontPlateShadow = false,
}: HomePlateProps) {
    const { chartOptions, settings } = useChartOptions()
    const shouldShowNormalized = useShouldShowNormalized()
    const strikeZone = useStrikeZoneType()

    const showPlateDepth = shouldShowPlateDepthLegend(chartOptions)
    const shouldShowZoneDepthText =
        showPlateDepth && useFlag('showZoneDepthText')
    const shouldShowZoneScaleText =
        showPlateDepth && useFlag('showZoneScaleText') && settings.data.length

    const wrapperTransform = pitcherPerspective
        ? 'translate(190, 435)'
        : 'translate(190, 400) scale(1.13, 0.954)'
    const homeplatePathD = pitcherPerspective
        ? 'M15.65,12.74S58.68,.52,58.68,.52l44.2,12.22,16.74,36H.75L15.65,12.74Z'
        : 'M.5,33.51s52.15,17.56,52.15,17.56l53.21-17.56L91.81,.85,13.85,.5,.5,33.51Z'

    const isActualHeight = strikeZone === 'personal' || !shouldShowNormalized
    const shrinkTest =
        showMidPlateShadow && showFrontPlateShadow && !isActualHeight

    const fontSize = shrinkTest ? 15 : 18

    return (
        <>
            <defs>
                <style>{`.e{fill:#eaeaea;stroke:#d6d6d6;stroke-miterlimit:10;}`}</style>
            </defs>
            {/* This sucks, hardcoding for now */}
            <g transform={wrapperTransform}>
                <g>
                    <path className="e" d={homeplatePathD} />
                </g>
            </g>
            <g fontSize={fontSize}>
                {shouldShowZoneScaleText && (
                    <ZoneScaleText
                        shouldShowNormalized={shouldShowNormalized}
                        strikeZone={strikeZone}
                    />
                )}
                {shouldShowZoneDepthText && (
                    <ZoneDepthText
                        showMidPlateShadow={showMidPlateShadow}
                        showFrontPlateShadow={showFrontPlateShadow}
                        pitcherPerspective={pitcherPerspective}
                    />
                )}
            </g>
        </>
    )
}
